import { parseISO, format } from "date-fns";
import { el, enUS, es, ja, zhCN } from "date-fns/locale";

const localeMap = {
  zh: zhCN,
  el: el,
  en: enUS,
  "en-us": enUS,
  es: es,
  ja: ja,
};

export const dateFnsLocale = (locale: string) => localeMap[locale] || enUS;

function toDate(date: Date | string | undefined): Date | undefined {
  if (!date) return undefined;
  return date instanceof Date ? date : parseISO(date);
}

export function isDifferentDays(
  date1: Date | string | undefined,
  date2: Date | string | undefined,
  date3: Date | string | undefined,
): boolean {
  const dates = [toDate(date1), toDate(date2), toDate(date3)],
    validDates = dates.filter((date) => date !== undefined) as Date[],
    datesAsStrings = validDates.map((date) => date.getDate());

  // Return true if the dates are not all the same.
  return new Set(datesAsStrings).size !== 1;
}

// by providing a default string of 'PP' or any of its variants for `formatStr`
// it will format dates in whichever way is appropriate to the locale
export function formatWithLocale(
  date: Date | string | undefined,
  formatStr = "PP",
): string {
  if (!date) return "";
  const dateObj = date instanceof Date ? date : parseISO(date);
  return format(dateObj, formatStr, {
    locale: dateFnsLocale(global.window.language || "en"),
  });
}

export function formatTime(
  date: Date | string | undefined,
  timeFormat = "twelve",
): string {
  if (!date) return "";
  const dateObj = date instanceof Date ? date : parseISO(date);
  return format(dateObj, timeFormat == "twelve" ? "h:mm aaa" : "H:mm", {
    locale: dateFnsLocale(global.window.language || "en"),
  });
}
